interface ImportHeaderProps {
	text: string;
}

export const ImportHeader = ({ text }: ImportHeaderProps) => {
	return <th className="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
		{text}
	</th>
}